import { ImageDataLike } from 'gatsby-plugin-image'

export const fileToImageLikeData = (
  file: Queries.Maybe<Queries.File> | Queries.ImageSharp,
): ImageDataLike => file as unknown as ImageDataLike
